let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("34ktg"), load("h0zs6"), load("bRMot"), load("hXMba")]).then(() => parcelRequire('48ZOK'));